import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    actionsColumnKey,
    articleKey,
    bonusReportKey,
    bpiStatusColumnKey,
    closedColumnKey,
    closedOptionsPriceColumnKey,
    closedPositionKey,
    closedPositionsTitle,
    closedStockPriceColumnKey,
    initiatedColumnKey,
    initiatedKey,
    lastCloseColumnKey,
    marketRelativeStrengthColumnKey,
    modelPortfolioKey,
    nyseBpiKey,
    openedOptionsPriceColumnKey,
    openedStockPriceColumnKey,
    openedPositionKey,
    openPositionsTitle,
    optionsGainsColumnKey,
    peerRelativeStrengthColumnKey,
    positionSizeCalculatorKey,
    sectorColumnKey,
    sectorRelativeStrengthColumnKey,
    stanceColumnKey,
    sectorTreeKey,
    stockGainsColumnKey,
    tradeAlertKey,
    symbolColumnKey,
} from "@/types/products/product-definitions";
import { mtpcProductKey } from "@/types/permissions";

import {
    configureProductActionsMap,
    configureProductPortfolioActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = modelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: mtpcProductKey,
    modelPortfolioKeys: [ {
        key: openedPositionKey,
        title: openPositionsTitle,
        columnKeys: [
            symbolColumnKey,
            stanceColumnKey,
            sectorColumnKey,
            lastCloseColumnKey,
            bpiStatusColumnKey,
            sectorRelativeStrengthColumnKey,
            peerRelativeStrengthColumnKey,
            marketRelativeStrengthColumnKey,
            initiatedColumnKey,
            openedStockPriceColumnKey,
            openedOptionsPriceColumnKey,
            actionsColumnKey
        ]
    }, {
        key: closedPositionKey,
        title: closedPositionsTitle,
        columnKeys: [
            symbolColumnKey,
            sectorColumnKey,
            initiatedColumnKey,
            closedColumnKey,
            openedStockPriceColumnKey,
            closedStockPriceColumnKey,
            stockGainsColumnKey,
            openedOptionsPriceColumnKey,
            closedOptionsPriceColumnKey,
            optionsGainsColumnKey,
            actionsColumnKey
        ]
    } ]
}

const productActionTopicKeys = [
    bonusReportKey,
    modelPortfolioKey,
    tradeAlertKey,
    articleKey,
    nyseBpiKey,
    sectorTreeKey,
    positionSizeCalculatorKey
];

export function useMegaTrendProfitClub() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap =
        configureProductActionsMap( mtpcProductKey, productActionTopicKeys );

    const portfolioActionsMap =
        configureProductPortfolioActionsMap( 'MTPC',
            initiatedKey,
            closedPositionKey,
            productConfig.modelPortfolioKeys![ 0 ],
            productConfig.modelPortfolioKeys![ 1 ] );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        portfolioActionsMap,
        selectedView
    }
}
